import { SIGN_IN, ON_ERROR, LOG_OUT, ERROR_TXT, SIGN_UP, FETCH_CONTACT } from '../actionTypes'
const initialState = {
    currentUser: null,
    userName: '',
    userId: '',
    mobile: '',
    contactId: null,
    isLoggedIn: false,
    onError: false,
    error: '',
}
// 3023386605
export default function (state = initialState, action) {
    switch (action.type) {
        case SIGN_UP:
            return {
                ...state,
                userId: action.payload.pageId,
                currentUser: action.payload.email,
                userName: action.payload.pageName,
                contactId: action.payload.contactId,
                isLoggedIn: true,
                onError: false
            }
        case SIGN_IN:
            return {
                ...state,
                userId: action.payload._embedded.lofsoft_usersub[0].pageId,
                currentUser: action.payload._embedded.lofsoft_usersub[0].email,
                userName: action.payload._embedded.lofsoft_usersub[0].pageName,
                contactId: action.payload._embedded.lofsoft_usersub[0].contactId,
                isLoggedIn: true,
                onError: false,
            }
        case FETCH_CONTACT:
            return {
                ...state,
                mobile: action.payload.mobile
            }
        case ON_ERROR:
            return {
                ...state,
                onError: action.payload,
                isLoggedIn: false,
                mobile:''
            }
        case ERROR_TXT:
            return {
                ...state,
                onError: true,
                mobile:'',
                error: action.payload,
                isLoggedIn: false
            }
        case LOG_OUT:
            return {
                ...state,
                currentUser: action.payload,
                onError: false,
                userName: '',
                userId: '',
                mobile: '',
                contactId: null,
                isLoggedIn: false
            }
        default:
            return state;

    }
}